export const validTicker = (text) => /^[A-Za-z0-9$^][A-Za-z0-9._:/^=\-]{0,31}$/.test(text);
const word = (char) => !!char && /[A-Za-z0-9_]/.test(char);
const join = (char) => !!char && /[.\-/]/.test(char);
export const tickerBoundary = (text, start, end) => !(start > 0 && (word(text[start - 1]) || (join(text[start - 1]) && word(text[start - 2]))))
    && !(end < text.length && (word(text[end]) || (join(text[end]) && word(text[end + 1]))));

export function tickerSegments(text, tickers = []) {
    return protectedSegments(text, tickers, []);
}

export function protectedSegments(text, tickers = [], keywords = []) {
    const keywordSet = new Set(keywords);
    const symbols = [...new Set([...tickers, ...keywords])].filter(Boolean).sort((a, b) => b.length - a.length);
    const result = [];
    let start = 0;
    for (let i = 0; i < text.length;) {
        const ticker = symbols.find((value) => text.startsWith(value, i) && (keywordSet.has(value) || tickerBoundary(text, i, i + value.length)));
        if (!ticker) { i += 1; continue; }
        if (i > start) result.push({ text: text.slice(start, i) });
        result.push({ text: ticker, ticker: true, kind: keywordSet.has(ticker) ? 'keywords' : 'tickers' });
        i += ticker.length; start = i;
    }
    if (start < text.length) result.push({ text: text.slice(start) });
    return result;
}

export const remainingTickers = (text, tickers = []) => tickers.filter((ticker) => tickerSegments(text, [ticker]).some((segment) => segment.ticker));
export const tickerCandidates = (text) => [...new Set(text.match(/[A-Za-z0-9$^][A-Za-z0-9._:/^=\-]*/g) || [])]
    .filter((ticker) => validTicker(ticker) && remainingTickers(text, [ticker]).length > 0);

export const validKeyword = (text) => !!text.trim() && Array.from(text).length <= 200 && !text.includes('\0');
export const remainingKeywords = (text, keywords = []) => keywords.filter((keyword) => keyword && text.includes(keyword));
